import { Checkbox } from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  disclaimerAcceptedSelector,
  privacyPolicyAcceptedSelector,
  setDisclaimerAccepted,
  setPrivacyPolicyAccepted,
} from '../../store/slices/appSlice';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '../../config/assets.url.config';

import './DisclaimersComponent.css';

const DisclaimersComponent = () => {
  const disclaimerAccepted = useSelector(disclaimerAcceptedSelector);
  const privacyPolicyAccepted = useSelector(privacyPolicyAcceptedSelector);
  const dispatch = useDispatch();

  return (
    <div className='diclaimers-container'>
      <div className='checkbox-container'>
        <Checkbox
          checked={disclaimerAccepted}
          onChange={(e) => dispatch(setDisclaimerAccepted(e.target.checked))}
          label=''
        />
        <a target='_blank' rel='noreferrer' href={TERMS_OF_SERVICE_URL}>
          Terms of Service
        </a>
      </div>
      <div className='checkbox-container'>
        <Checkbox
          checked={privacyPolicyAccepted}
          onChange={(e) => dispatch(setPrivacyPolicyAccepted(e.target.checked))}
          label=''
        />
        <a target='_blank' rel='noreferrer' href={PRIVACY_POLICY_URL}>
          Privacy Policy
        </a>
      </div>
    </div>
  );
};

export default DisclaimersComponent;
